import { useState, useEffect } from "react";
import axios from "axios";
// css
import "./allOffersResult.css";
// others
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import { useRef } from "react";
import { ChevronRight, ChevronLeft } from "@material-ui/icons";
import { Link, useParams } from "react-router-dom";
import AllofferCard from "Utills/AllofferCard";
import CustomInput from "Utills/CustomInput/CustomInput";
import Loader from "Components/others/Loader";

// swiper slider configs
SwiperCore.use([Navigation]);

// api endpoint
let api_search = process.env.REACT_APP_API_OFFERS_SEARCH;
let api_domain = process.env.REACT_APP_API_DOMAIN;

//  THIS IS A ALL OFFER PAGE

const AllOffersResult = () => {
  const { locationName, query } = useParams();
  const [allOffersData, setAllOffersData] = useState([]);
  const [inputVal, setInputVal] = useState("");
  const [priceInputs, setPriceInputs] = useState({ min: undefined, max: 0 });
  const [loaded, setLoaded] = useState(false);
  //
  const navigationPrevRef_1 = useRef(null);
  const navigationNextRef_1 = useRef(null);
  //====== dummy data ======
  // let extras = ['SUP', 'Yacht Slide', 'Jetski', 'Kayak', 'Yacht Golf', 'Yoga session'];
  // let amenities = ['SUP', 'Yacht Slide', 'Jetski', 'Kayak', 'Yacht Golf', 'Yoga session'];
  // ========== currently active tab ==================
  const [activeTab, setActiveTab] = useState(0);
  // ============ filtered data according to tabs ====================
  const [selectedTabData, setSelectedTabData] = useState([]);
  //
  const [filteredData, setFilteredData] = useState([]);
  // ========= tabs data ==============
  let tabs = [
    { name: "All-Voyages", id: 0 },
    { name: "Full-day", id: 1 },
    { name: "3 days Cruises", id: 3 },
    { name: "4 days cruises", id: 4 },
    { name: "5 days cruises", id: 5 },
    { name: "6 days cruises", id: 6 },
    { name: "7 days cruises", id: 7 },
  ];

  //=============== get data ========
  useEffect(() => {
    const get_data = () => {
      let url =
        query === "flexible"
          ? api_search
          : `${api_search}/?location=${locationName}`;
      axios
        .get(url, { headers: { "Content-Type": "multipart/form-data" } })
        .then((response) => {
          setLoaded(true);
          let data = response?.data;
          // console.log(data)
          if (data?.status !== "error") {
            setAllOffersData([
              ...data?.intraday_offers,
              ...data?.overnight_offers,
            ]);
          }
        })
        .catch((err) => {
          setAllOffersData([]);
          console.log("Error ====>", err.message);
          setLoaded(true);
        });
    };
    get_data();
    return get_data();
  }, []);

  // ============== To filter Data according to selected days ================
  useEffect(() => {
    if (allOffersData?.length > 0) {
      let filtered = [];
      if (activeTab === 0) {
        setSelectedTabData(allOffersData);
        setFilteredData(allOffersData);
      } else {
        if (inputVal?.length > 0) {
          filtered = allOffersData.filter(
            (item) =>
              item?.duration?.toString() === activeTab?.toString() &&
              item?.people === parseInt(inputVal)
          );
        } else {
          filtered = allOffersData.filter(
            (item) => item?.duration?.toString() === activeTab?.toString()
          );
        }
        setSelectedTabData(filtered);
        setFilteredData(filtered);
      }
    }
    setPriceInputs({ min: 0, max: 0 });
    setInputVal("");
  }, [allOffersData, activeTab]);

  // console.log(activeTab)
  // console.log(loaded)
  // console.log(selectedTabData)
  // console.log("=-=-=-=-=-",allOffersData)

  // ====== search by guests ==================
  const handleGuestSearch = (e) => {
    let { value } = e.target;
    setInputVal(value);
    if (value?.length > 0 && selectedTabData?.length > 0 && loaded) {
      let searched = selectedTabData?.filter(
        (val) => val?.people === parseInt(value)
      );
      setFilteredData(searched);
    } else {
      if (activeTab === 0) {
        setFilteredData(selectedTabData);
      } else {
        let filtered = selectedTabData.filter(
          (item) => item?.duration?.toString() === activeTab?.toString()
        );
        setFilteredData(filtered);
      }
    }
  };
  // ====== search by Price min & max ==================
  const handlePriceSearch = (e) => {
    let { value, name } = e.target;
    let inputVal = parseInt(value) || 0;
    let searched = [];
    if (
      value?.toString()?.length > 0 &&
      selectedTabData?.length > 0 &&
      loaded
    ) {
      setPriceInputs({ ...priceInputs, [name]: inputVal });
      if (name === "min") {
        if (priceInputs.max && priceInputs.max > 0) {
          searched = selectedTabData.filter(
            (x) => x.price >= inputVal && x.price <= priceInputs.max
          );
        }
      } else {
        searched = selectedTabData.filter(
          (x) => x.price >= 0 && x.price <= inputVal
        );
      }
      setFilteredData(searched);
    } else {
      // setFilteredData(selectedTabData);
      setPriceInputs({ ...priceInputs, [name]: 0 });
    }
  };

  // console.log("selected tab", selectedTabData)
  // console.log("filtered tab", filteredData)

  useEffect(() => {
    if (priceInputs.max === 0 && priceInputs.min === 0) {
      setFilteredData(selectedTabData);
    } else if (priceInputs.max === 0) {
      setFilteredData(
        selectedTabData.filter((x) => x.price >= priceInputs.min)
      );
    }
  }, [priceInputs]);

  return (
    <div className="alloffers-result-page">
      {/*  */}
      <div className="cs_container">
        <div className="row">
          <div className="col-md-6">
            <span className="text-sec fw-bold">
              [ {locationName === "unknown" ? "Not Selected" : locationName} ]
            </span>
            <h2>Available Cruises</h2>
            {/* <p className="py-3">Here are the lists for the Intraday & OverNight</p> */}
          </div>
          <div className="col-md-6 d-flex flex-column justify-content-end align-items-end text-right">
            <span className="text-sec">
              Any questions ? &nbsp;{" "}
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                <path
                  d="M11 20.625C8.44729 20.625 5.99913 19.6109 4.1941 17.8059C2.38906 16.0009 1.375 13.5527 1.375 11C1.375 8.44729 2.38906 5.99913 4.1941 4.1941C5.99913 2.38906 8.44729 1.375 11 1.375C13.5527 1.375 16.0009 2.38906 17.8059 4.1941C19.6109 5.99913 20.625 8.44729 20.625 11C20.625 13.5527 19.6109 16.0009 17.8059 17.8059C16.0009 19.6109 13.5527 20.625 11 20.625ZM11 22C13.9174 22 16.7153 20.8411 18.7782 18.7782C20.8411 16.7153 22 13.9174 22 11C22 8.08262 20.8411 5.28473 18.7782 3.22183C16.7153 1.15893 13.9174 0 11 0C8.08262 0 5.28473 1.15893 3.22183 3.22183C1.15893 5.28473 0 8.08262 0 11C0 13.9174 1.15893 16.7153 3.22183 18.7782C5.28473 20.8411 8.08262 22 11 22Z"
                  fill="#92B9D5"
                />
                <path
                  d="M7.22588 7.95575C7.224 8.00015 7.23122 8.04447 7.2471 8.08598C7.26298 8.1275 7.28718 8.16532 7.31822 8.19713C7.34925 8.22894 7.38647 8.25407 7.42758 8.27096C7.46869 8.28786 7.51282 8.29616 7.55725 8.29537H8.69163C8.88138 8.29537 9.03263 8.14 9.05738 7.95162C9.18113 7.04962 9.79988 6.39238 10.9026 6.39238C11.8459 6.39238 12.7094 6.864 12.7094 7.99837C12.7094 8.8715 12.1951 9.273 11.3825 9.8835C10.4571 10.5559 9.72425 11.341 9.7765 12.6156L9.78063 12.914C9.78207 13.0042 9.81892 13.0902 9.88323 13.1535C9.94754 13.2168 10.0342 13.2523 10.1244 13.2522H11.2395C11.3307 13.2522 11.4181 13.216 11.4826 13.1516C11.547 13.0871 11.5833 12.9997 11.5833 12.9085V12.7641C11.5833 11.7769 11.9586 11.4895 12.972 10.7209C13.8094 10.0842 14.6825 9.3775 14.6825 7.89388C14.6825 5.81625 12.928 4.8125 11.0071 4.8125C9.265 4.8125 7.3565 5.62375 7.22588 7.95575ZM9.36675 15.8799C9.36675 16.6128 9.95113 17.1545 10.7555 17.1545C11.5929 17.1545 12.169 16.6128 12.169 15.8799C12.169 15.1209 11.5915 14.5874 10.7541 14.5874C9.95113 14.5874 9.36675 15.1209 9.36675 15.8799Z"
                  fill="#92B9D5"
                />
              </svg>
            </span>
            <Link
              to="/contact"
              className="mt-2 dark-btn px-3 text-white py-2 d-flex justify-content-center align-items-center"
            >
              {/* <img src={CalenderImg} alt="" /> &nbsp; */}
              {/* 00/00/0000 */}
              Contact US
            </Link>
          </div>
        </div>
      </div>
      {/* offers tabs */}
      <div className="all_offers_btns_row_wrap my-md-4 my-2">
      <div className="btns_row cs_container  ">
        {tabs.map((v, i) => {
          return (
            <button
              className={`${
                activeTab === v.id
                  ? "activeTab_btn_cs with_sec text-sec"
                  : "text-dark "
              } csTabs_btn_ds `}
              onClick={() => setActiveTab(v.id)}
              key={i}
            >
              {v.name}
            </button>
          );
        })}
      </div>
      </div>
      {/*  */}
      <div className="cs_container">
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          {/* by guests */}
          <div className="text-left d-flex justify-content-start align-items-center p-0 col-sm-6 col-12">
            {/* <div className="d-flex mt-3 justify-content-start align-items-center">
                            <span className="mx-2">Guests</span>
                            <select name="guests" onChange={handleGuestSearch} value={inputVal} className="cs-select-pop px-4">
                                <option value="">All</option>
                                {[1, 2, 3, 4, 5, 6].map((v, i) => {
                                    return (
                                        <option key={i} value={v}>{v}</option>
                                    )
                                })}
                            </select>
                        </div> */}

            <label htmlFor="">Guests</label>

            <div className="my-auto mx-2">
              <CustomInput
                type="search"
                blueborder
                name="guests"
                placeholder="0"
                wrapperClassName="my-0"
                className="guest_input"
                onChange={handleGuestSearch}
                value={inputVal}
              />
            </div>
          </div>
          {/* by price */}
          {/* <div className="d-flex mt-sm-0 mt-2 flex-column">
                        <div className="d-flex text-center my-2 justify-content-center align-items-center">
                            <h5>Price range</h5>
                        </div>
                        <div className="my-auto d-flex align-items-center">
                            <span className="mx-2">Min</span>
                            <CustomInput
                                type="number"
                                blueborder
                                name="min"
                                placeholder="€"
                                wrapperClassName="my-0"
                                className="guest_input text-center text-sec"
                                onChange={handlePriceSearch}
                                value={priceInputs.min === 0 ? "" : priceInputs.min}
                            />
                            <span className="mx-2">Max</span>
                            <CustomInput
                                type="number"
                                blueborder
                                name="max"
                                placeholder="€"
                                wrapperClassName="my-0"
                                className="guest_input text-center text-sec"
                                onChange={handlePriceSearch}
                                value={priceInputs.max > 0 ? priceInputs.max : ""}
                            />
                        </div>
                    </div> */}
        </div>

        {/* offers slider */}
        <div className="row mt-4">
          <div className="col-12">
            {loaded ? (
              filteredData?.length > 0 ? (
                <div className="alloffers-result-slider-container">
                  <Swiper
                    className="all-offers-res-swiper-container"
                    onBeforeInit={(swiper) => {
                      swiper.params.navigation.prevEl =
                        navigationPrevRef_1.current;
                      swiper.params.navigation.nextEl =
                        navigationNextRef_1.current;
                    }}
                    navigation={{
                      prevEl: navigationPrevRef_1.current,
                      nextEl: navigationNextRef_1.current,
                    }}
                    spaceBetween={15}
                    slidesPerView={4}
                    grabCursor
                    breakpoints={{
                      100: {
                        slidesPerView: 1,
                      },
                      390: {
                        slidesPerView: 1,
                      },
                      550: {
                        slidesPerView: 2,
                      },
                      992: {
                        slidesPerView: 3,
                      },
                      1250: {
                        slidesPerView: 4,
                      },
                    }}
                  >
                    {filteredData?.map((data, i) => (
                      <SwiperSlide key={i} className="all-offers-slider-card">
                        <AllofferCard
                          data={{
                            tittle: data?.title,
                            price: data?.price,
                            viewMoreLink:
                              window.origin + "/OfferDetails/" + data?.offer_id,
                            bookNowLink: "/confirmBooking/" + data?.offer_id,
                            amenities: data?.amenities,
                            extras: data?.extras,
                            residenceText: data?.brief_description,
                            users: data?.people,
                            thumbnail: api_domain + data?.thumbnail,
                            img1: null,
                            img2: null,
                            period: data?.duration +  (parseInt(data?.duration) > 1 ? " days" : " day"),
                            location: data?.location,
                            itinerary: data?.itinerary,
                          }}
                        />
                      </SwiperSlide>
                    ))}
                    <div
                      ref={navigationPrevRef_1}
                      className="alloffers-result-slider-cs-nav prev-bt d-flex justify-content-center align-items-center cursor-pointer"
                    >
                      <ChevronLeft />
                    </div>
                    <div
                      ref={navigationNextRef_1}
                      className="alloffers-result-slider-cs-nav next-bt d-flex justify-content-center align-items-center cursor-pointer"
                    >
                      <ChevronRight />
                    </div>
                  </Swiper>
                </div>
              ) : (
                <div className="mt-5 text-center px-4 mb-5 pt-4 pb-4">
                  <h4>No Offers are found!</h4>
                </div>
              )
            ) : (
              <div className="mt-5 mb-5">
                <Loader />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllOffersResult;
